// extracted by mini-css-extract-plugin
module.exports = {"signTabs__container":"SignTabs_signTabs__container__Ap5gT","signTabs__navigation":"SignTabs_signTabs__navigation__H09f8"};